/**
 * Custom `isArrayOfMinLength` operator.
 *
 * Compares an array fact's length against a numeric minimum provided in the
 * rule JSON. Used by funnel-engine `chooseNextStep` to gate `goto_step`
 * branches on multi-select answers (e.g. `vibe_tags` requires at least 1
 * selection before the user advances) — see the SecretMate funnel plan §5.1.
 *
 * Rule JSON shape:
 *   { fact: "answers.vibe_tags", operator: "isArrayOfMinLength", value: 1 }
 *
 * Non-array facts and non-finite values evaluate `false` so a missing or
 * mistyped fact never accidentally satisfies a "must have N selections" gate.
 */

const isArrayOfMinLengthEvaluator = (factValue: unknown, ruleValue: unknown): boolean => {
  if (!Array.isArray(factValue)) return false;
  if (typeof ruleValue !== "number" || !Number.isFinite(ruleValue)) return false;
  return factValue.length >= ruleValue;
};

/**
 * Tuple consumed by `Engine.addOperator(name, callback)`.
 * Spread it: `engine.addOperator(...isArrayOfMinLengthOperator)`.
 */
const isArrayOfMinLengthOperator = ["isArrayOfMinLength", isArrayOfMinLengthEvaluator] as const;

export default isArrayOfMinLengthOperator;
